import styled from "styled-components";
import { mixFont } from "../../global/mixins";
import Colors from "../../global/color";
// import LinkHandler from "./../LinkHandler";
// import { Button } from '@bootstrap-styled/v4';

export const Constants = {
  defaults: {
    padding: "55px 0 0 0",
    size: {
      width: 200,
      height: 38,
    },
    border: {
      size: 1,
    },
    font: {
      family: "FuturaPT-Medium",
      size: 12,
      height: 12,
      spacing: 3,
    },
  },
  darkMode: {
    border: {
      borderColor: "#FFFFFF",
    },
    font: {
      color: "#FFFFFF",
    },
    hover: {
      color: Colors.gold, // "#c69f2d",
      borderColor: Colors.goldLight, //"#c69f2d",
      background: "#000000",
    },
  },
  lightMode: {
    border: {
      borderColor: "#000000",
    },
    font: {
      color: "#000000",
    },
    hover: {
      color: Colors.gold, // "#c69f2d",
      borderColor: Colors.goldLight, //"#c69f2d",
      background: "#FFFFFF",
    },
  },
};

const getTypeColor = (type, target, attribute) => {
  if (type === "lightMode" || type === "darkMode") {
    return Constants[type][target][attribute];
  }

  return Constants.lightMode[target][attribute];
};

const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: ${({ padding }) => (padding !== undefined ? padding : "55px 0 0 0")};
`;

const StyledButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  background: transparent;
  text-decoration: none;
  letter-spacing: 3px;
  -webkit-transition: color 0.3s ease-out, border-color 0.3s ease-out;
  -moz-transition: color 0.3s ease-out, border-color 0.3s ease-out;
  -ms-transition: color 0.3s ease-out, border-color 0.3s ease-out;
  -o-transition: color 0.3s ease-out, border-color 0.3s ease-out;
  transition: color 0.3s ease-out, border-color 0.3s ease-out;

  ${mixFont(Constants.defaults.font)};

  // width: ${Constants.defaults.size.width}px;
  height: ${Constants.defaults.size.height}px;
  border: ${Constants.defaults.border.size}px solid;
  padding: 0px 25px;
  color: ${({ type }) => getTypeColor(type, "font", "color")};
  border-color: ${({ type }) => getTypeColor(type, "border", "borderColor")};

  &:hover {
    text-decoration: none;
    color: ${({ type }) => getTypeColor(type, "hover", "color")};
    border-color: ${({ type }) => getTypeColor(type, "hover", "borderColor")};
    background: ${({ type }) => getTypeColor(type, "hover", "background")};
  }
`;

export { StyledButtonWrapper, StyledButton };
